import Navbar from './Navbar'
import Content from './Content'
import {BrowserRouter as Router} from 'react-router-dom'
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import './css/main.css'
import './css/talkbubble.css'
import { useState } from 'react'



function App(props) {
 const [wid,setWid]= useState(false)
  return (
    <div>
      <Router>
      <Navbar state = {wid} setState = {setWid}/>
      <Content  state = {wid} setState={setWid} sid={props.sid}/>
      </Router>
      
    </div>
  );
}

export default App;
